module.exports = __webpack_public_path__ + "img/flag_tz.2b59be52.jpg";